import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { addHydrateReducer } from "../../utils/hydrateReducer";

export interface IGenre {
  id: number;
  name: string;
  arts_count?: number;
  subgenres?: IGenre[];
  url: string;
  uuid?: string;
  breadcrumbs?: Pick<IGenre, "id" | "name" | "uuid" | "url">[];
  alternate_urls?: {
    url: string;
    language: string;
  }[];
}

interface IGenresState {
  popup: IGenresPopup;
}

interface IGenresPopup {
  history: IGenre[];
  currentGenre: IGenre | null;
  isOpen: boolean;
}

const initialState: IGenresState = {
  popup: {
    history: [],
    currentGenre: null,
    isOpen: false,
  },
};

export const genresSlice = createSlice({
  name: "global/header/genres",
  initialState,
  reducers: {
    setCurrentGenre: (
      state: IGenresState,
      action: PayloadAction<IGenresPopup["currentGenre"]>
    ): void => {
      state.popup.currentGenre = action.payload;
    },
    setHistory: (
      state: IGenresState,
      action: PayloadAction<IGenresPopup["history"]>
    ): void => {
      state.popup.history = action.payload;
    },
    setOpenPopup: (
      state: IGenresState,
      action: PayloadAction<boolean>
    ): void => {
      state.popup.isOpen = action.payload;
    },
  },
  extraReducers: builder => {
    addHydrateReducer(builder, "global.genres");
  },
});

export const { setCurrentGenre, setHistory, setOpenPopup } =
  genresSlice.actions;

export default genresSlice.reducer;
